module.exports = __webpack_public_path__ + "img/img_01@2x.49071309.png";